import type { KnownAccessoryTypeType } from '@alpinehomeair/common';

const QUANTITY_ACCESSORY_TYPE_CODES: ReadonlySet<string> =
  new Set<KnownAccessoryTypeType>(['line_set_cover']);

export const usesQuantitySelection = (code: string): boolean =>
  QUANTITY_ACCESSORY_TYPE_CODES.has(code);
